import React from 'react';

const Rating = ({ rating }) => {
    return (
        <div className="flex items-center">
            {Array.from({ length: Math.ceil(rating) }).map((_, index) => (
                <div key={index} className="text-yellow-500">
                    ★
                </div>
            ))}
            {Array.from({ length: 5 - Math.ceil(rating) }).map((_, index) => (
                <div key={index} className="text-gray-500">
                    ★
                </div>
            ))}
        </div>
    );
};

export default Rating;
